import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { SessionService } from '../../store/services/session.service';
import { IUserSessionData, UserType } from '../../store/models/user.model';

@Injectable()
export class FranchiseAccessGuard implements CanActivate {
  constructor(
    private readonly sessionService: SessionService,
    private readonly router: Router,
  ) {
  }

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
    const superAdminOnly = route.data.superAdminOnly === true;

    return this.sessionService.onReady()
      .pipe(
        filter((session): session is IUserSessionData => !!session),
        map(session => {
          const isSuperAdmin = session.user_type === UserType.MASTER && session.id === 1;
          const canAccess = session.user_type === UserType.FRANCHISE || isSuperAdmin;

          if (superAdminOnly) {
            return isSuperAdmin ? true : this.router.createUrlTree(['/']);
          }

          return canAccess ? true : this.router.createUrlTree(['/']);
        }),
      );
  }
}
